import React from 'react';
import PropTypes from 'prop-types';
import WidgetTable from 'components/kea/tables/WidgetTable';
import { linkToQueryDetail } from 'util/appUtils';
import { useLocalizedMessage } from 'util/useLocalizedMessage';
import AnalyticsMetricBar from 'app/routes/search/analytic/components/AnalyticsMetricBar';
import CardContainerSmall from '../../CardContainerSmall';

const BriefPopularQueries = ({
  queryPopular,
  currentShop,
}) => {
  const { isFetching, data, error } = queryPopular;
  const localizeMessage = useLocalizedMessage();
  const rows = Array.isArray(data) ? data : [];
  const maximumSearches = Math.max(1, ...rows.map((row) => Number(row.total || 0)));
  const headCells = [
    { id: '#', numeric: false, label: '#' },
    { id: 'query', numeric: false, label: localizeMessage('analytics.table.query') },
    {
      id: 'total',
      numeric: true,
      label: localizeMessage('analytics.table.total'),
      render: (value) => (
        <AnalyticsMetricBar
          value={value}
          maximum={maximumSearches}
          label={localizeMessage('analytics.table.total')}
          tone="searches"
        />
      ),
    },
  ];

  const sortDesc = (a, b) => b.total - a.total;
  const attachLinkToArray = (e) => ({ ...e, query: linkToQueryDetail(currentShop, e.query) });
  const prepareRows = (rows) => {
    if (Array.isArray(rows)) {
      return [...rows]
        .sort(sortDesc)
        .slice(0, 7)
        .map(attachLinkToArray);
    }
    return [];
  };

  return (
    <CardContainerSmall
      error={error}
      isFetching={isFetching}
      headerId="search.analytics.queryPopular.header"
      showMoreUrl={`/app/${currentShop}/search/analytic/query-popular`}
    >
      <WidgetTable
        hidePagination
        rows={prepareRows(rows)}
        headCells={headCells}
      />
    </CardContainerSmall>
  );
};

BriefPopularQueries.propTypes = {
  queryPopular: PropTypes.shape({
    isFetching: PropTypes.bool,
    data: PropTypes.array,
    error: PropTypes.any,
  }).isRequired,
  currentShop: PropTypes.string.isRequired,
};

export default BriefPopularQueries;
